import getFloorTradeDeviationMagnitudes from "../../services/getters/project_getters/get_floor_trade_deviation_magnitudes";
import loadFloorTradeDeviationMagnitudes from "../../actions/dashboard/load_floor_trade_deviation_magnitudes";
import useQueryWithState from "../use_query_with_state";

const useFloorTradeDeviationMagnitudes = (projectId: string, enabled: boolean = true) =>{
  return useQueryWithState(
    ["useFloorTradeDeviationMagnitudes", projectId],
    loadFloorTradeDeviationMagnitudes,
    getFloorTradeDeviationMagnitudes,
    { enabled: enabled && !!projectId, refetchOnMount: "always" },
    { projectId },
    projectId,
    false
  );
};

export default useFloorTradeDeviationMagnitudes;